export * from "./friend";

export enum PotsActionType {
  Post = `post`,
  Comment = `post`,
}

export enum PostType {
  Post = "Post",
  Article = "Article",
  Event = "Event",
}

export enum FriendTab {
  Suggestions = "Suggestions",
  Requests = "Requests",
  Friends = "Friends",
}
